import { __awaiter } from "tslib";
import { default as ScriptLoaderUtil } from '../util/ScriptLoaderUtil';
import { Logger } from '@as-react/logger';
let scriptInitialized = false;
export const useSaferpayDeviceFingerPrinting = (dfpBaseUrl, session_id, instanceId) => __awaiter(void 0, void 0, void 0, function* () {
    if (!scriptInitialized) {
        scriptInitialized = true;
        const urlParams = new URLSearchParams({ session_id, instanceId, pageId: 'P' });
        const dfpScriptUrl = `${dfpBaseUrl}?${urlParams.toString()}`;
        try {
            yield ScriptLoaderUtil.loadScript(dfpScriptUrl, 'saferpay-device-fingerprinting', true);
            window.dfp.doFpt(document);
        }
        catch (error) {
            Logger.logError(error);
        }
    }
});
